// Deterministic price formatting that does NOT depend on the visitor's locale.
// Using locale-aware toLocaleString() can emit non-breaking / narrow-no-break
// space separators (U+00A0 / U+202F) that some brand fonts lack, rendering as
// "tofu" boxes (e.g. for visitors with a de-AT locale). This formatter uses
// ASCII-only grouping with a period, so it renders identically everywhere.
export function formatEur(amount: number): string {
  const rounded = Math.round(amount)
  return String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
